import formatTableJson from '@manage/config/tableComponentParams.js'
export default formatTableJson([
  {
    filed: 'bitIndex',
    label: '位号',
    formatFn: function (_, row) {
      return 'B' + row.bitIndex
    }
  },
  {
    filed: 'excType',
    label: '异常类型',
    formatFn: function (_, row) {
      let dic = {
        '01': '预警',
        '02': '故障'
      }
      return dic[row.excType]
    }
  },
  {
    filed: 'excSituation',
    label: '异常情况'
  },
  {
    filed: 'excDescribe',
    label: '异常描述'
  },
  {
    filed: 'delayTime',
    label: '自动上报时间(h)',
    formatFn: function (_, row) {
      if (row.delayTime === -1) {
        return '不上报'
      } else {
        return row.delayTime
      }
    }
  }
])
